import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import SimpleAlert from "../../../../components/display/SimpleAlert";
import { STATUSES } from "../../../../enums/AppointmentStatus";
import useUser from "../../../../hooks/useUser";
import { isInternalAppointment } from "../utils/getAppointmentOwner";

export default function AppointmentAlerts({ appointment }) {
  const { t } = useTranslation();
  const { roles } = useUser();
  const pet = appointment?.pet;

  return (
    <Fragment>
      <SimpleAlert
        mb={2}
        message={t("InternalAppointmentAlert")}
        severity={"info"}
        show={isInternalAppointment(appointment)}
        testId={"appointment.details.internal-alert"}
      />
      <SimpleAlert
        mb={2}
        message={"AppointmentNeedsToBeResolvedDesc"}
        severity={"warning"}
        show={roles.adminOrEmployee && appointment?.status === STATUSES.RESOLVED}
        testId={"appointment.details.needs-resolved-alert"}
      />
      <SimpleAlert
        mb={2}
        message={t("DeceasedPetAppointmentAlert")}
        severity={"warning"}
        show={Boolean(pet?.deceased)}
        testId={"appointment.details.deceased-alert"}
      />
      <SimpleAlert
        mb={2}
        message={t("NoPetAppointmentAlert")}
        severity={"warning"}
        show={!pet}
      />
    </Fragment>
  );
}
